import * as React from "react";

;
export const ChevronLeftSmll = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}><path fill="#100722" d="m10.06 12 5.47 5.47-1.06 1.06L7.94 12l6.53-6.53 1.06 1.06L10.06 12Z" /></svg>;